import type { ApiConfig, FetchApiData, FetchSubTypes } from '../types'
import { convertHistoryApiConfig } from './convertHistory/constants'
import { fetchApiData as fetchConvertHistoryApiData } from './convertHistory/fetchApiData'
import { depositHistoryApiConfig } from './depositHistory/constants'
import { fetchApiData as fetchDepositHistoryApiData } from './depositHistory/fetchApiData'
import { spotTradeHistoryApiConfig } from './spotTradeHistory/constants'
import { fetchApiData as fetchSpotTradeHistoryApiData } from './spotTradeHistory/fetchApiData'
import { fetchSubTypes as fetchSpotTradeHistorySubTypes } from './spotTradeHistory/fetchSubTypes'
import { usdFutureHistoryApiConfig } from './usdFutureHistory/constants'
import { fetchApiData as fetchUsdFutureHistoryApiData } from './usdFutureHistory/fetchApiData'
import { withdrawalHistoryApiConfig } from './withdrawalHistory/constants'
import { fetchApiData as fetchWithdrawalHistoryApiData } from './withdrawalHistory/fetchApiData'

export const binanceApiConfigs = {
  [convertHistoryApiConfig.type]: convertHistoryApiConfig,
  [depositHistoryApiConfig.type]: depositHistoryApiConfig,
  [spotTradeHistoryApiConfig.type]: spotTradeHistoryApiConfig,
  [usdFutureHistoryApiConfig.type]: usdFutureHistoryApiConfig,
  [withdrawalHistoryApiConfig.type]: withdrawalHistoryApiConfig,
} as const satisfies Record<string, ApiConfig>

export type BinanceApiType = keyof typeof binanceApiConfigs

export const binanceApiTypes = Object.keys(
  binanceApiConfigs,
) as BinanceApiType[]

export const fetchBinanceApiDataFuncs = {
  [convertHistoryApiConfig.type]: fetchConvertHistoryApiData,
  [depositHistoryApiConfig.type]: fetchDepositHistoryApiData,
  [spotTradeHistoryApiConfig.type]: fetchSpotTradeHistoryApiData,
  [usdFutureHistoryApiConfig.type]: fetchUsdFutureHistoryApiData,
  [withdrawalHistoryApiConfig.type]: fetchWithdrawalHistoryApiData,
} as const satisfies Record<string, FetchApiData>

export const fetchBinanceSubTypesFuncs = {
  [convertHistoryApiConfig.type]: undefined,
  [depositHistoryApiConfig.type]: undefined,
  [spotTradeHistoryApiConfig.type]: fetchSpotTradeHistorySubTypes,
  [usdFutureHistoryApiConfig.type]: undefined,
  [withdrawalHistoryApiConfig.type]: undefined,
} as const satisfies Record<string, FetchSubTypes | undefined>

export { getCurrentBinanceAssets } from './getCurrentAsset'
